import React, { createContext, useState, useEffect, useRef } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Logout handler
  const logout = async () => {
    setToken(null);
    setUser(null);
    await localStorage.removeItem("token");
    await localStorage.removeItem("user");
  };

  const logoutRef = useRef(logout);
  logoutRef.current = logout;

  // Restore login on app start
  useEffect(() => {
    const restoreSession = async () => {
      try {
        const storedToken = await localStorage.getItem("token");
        const storedUser = await localStorage.getItem("user");
        if (storedToken) setToken(storedToken);
        if (storedUser) setUser(JSON.parse(storedUser));
      } catch (e) {
        console.log("Restore session error", e);
      } finally {
        setLoading(false);
      }
    };
    restoreSession();
  }, []);

  // Listen for global logout (e.g. deactivated account)
  useEffect(() => {
    const handleAuthLogout = () => {
      logoutRef.current();
    };
    window.addEventListener("auth:logout", handleAuthLogout);
    return () => window.removeEventListener("auth:logout", handleAuthLogout);
  }, []);

  //updateProfile
  const updateProfile = async (updatedProfile) => {
    await localStorage.setItem("user", JSON.stringify(updatedProfile));
    setUser(updatedProfile);
  };

  // Login handler
  const login = async (token, userData) => {
    setToken(token);
    setUser(userData);
    await localStorage.setItem("token", token);
    await localStorage.setItem("user", JSON.stringify(userData));
    if (window.axios) {
      window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  };

  return (
    <AuthContext.Provider
      value={{token, user, login, logout, updateProfile, loading}}>
      {children}
    </AuthContext.Provider>
  );
};
